













import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'
import { PathHelper } from '@/helper/pathHelper'
import { SVGPathData } from 'svg-pathdata';

@Component({
  components: {
  },
})
export default class PatternCell extends Vue 
{
    @Prop() private selected! : boolean;
    @Prop() private pattern! : {pattern : number, cornerNumber : number}

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }

    private onClick()
    {
        this.$emit("select");
    }

    private get viewBox()
    {
        // pxと合わせて描画しやすくする
        return "0, 0, 160, 160";
    }

    private get path()
    {
        var width = 100;
        var height = 100;
        var outHeight = { height : 100 };
        var pattern = this.pattern.pattern;
        var cornerNumber = this.pattern.cornerNumber;
        var x = (160 - width ) / 2;
        var y = (160 - height) / 2;
        var path = PathHelper.createPattern(pattern, cornerNumber, x, y, width, height, 0, 0, 0, true, outHeight);
        if(height != outHeight.height)
        {
            // 位置調整
            var fixY = (160 - outHeight.height) / 2;
            var tempPath = new SVGPathData(path);
            tempPath.translate(0, -y);
            tempPath.translate(0, fixY);
            path = tempPath.encode();
        }
        return path;
    }
   
}
